export default __webpack_public_path__ + "static/media/patti_murillo_INTV_070621_mixdown_0821-0856.06932341.wav";